import React from 'react';

const SettingsSkeleton: React.FC = () => {
  return (
    <div className="space-y-8">
      {/* Profile Settings Skeleton */}
      <div className="rounded-xl bg-light-card dark:bg-dark-card border border-light-border dark:border-dark-border p-6">
        <div className="relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 dark:via-white/10 to-transparent skeleton-wave" />
          <div className="h-7 w-1/4 bg-light-hover dark:bg-dark-hover rounded-lg mb-6" />
          <div className="space-y-6">
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
              {[1, 2].map((i) => (
                <div key={i}>
                  <div className="h-5 w-1/4 bg-light-hover dark:bg-dark-hover rounded mb-2" />
                  <div className="h-10 bg-light-hover dark:bg-dark-hover rounded-lg" />
                </div>
              ))}
            </div>
            <div>
              <div className="h-5 w-1/4 bg-light-hover dark:bg-dark-hover rounded mb-2" />
              <div className="h-10 bg-light-hover dark:bg-dark-hover rounded-lg" />
            </div>
            <div className="flex justify-end">
              <div className="h-10 w-32 bg-light-hover dark:bg-dark-hover rounded-lg" />
            </div>
          </div>
        </div>
      </div>

      {/* Password Change Skeleton */}
      <div className="rounded-xl bg-light-card dark:bg-dark-card border border-light-border dark:border-dark-border p-6">
        <div className="relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 dark:via-white/10 to-transparent skeleton-wave" />
          <div className="h-7 w-1/4 bg-light-hover dark:bg-dark-hover rounded-lg mb-6" />
          <div className="space-y-6">
            {[1, 2, 3].map((i) => (
              <div key={i}>
                <div className="h-5 w-1/4 bg-light-hover dark:bg-dark-hover rounded mb-2" />
                <div className="h-10 bg-light-hover dark:bg-dark-hover rounded-lg" />
              </div>
            ))}
            <div className="flex justify-end">
              <div className="h-10 w-32 bg-light-hover dark:bg-dark-hover rounded-lg" />
            </div>
          </div>
        </div>
      </div>

      {/* Token Limits Skeleton */}
      <div className="rounded-xl bg-light-card dark:bg-dark-card border border-light-border dark:border-dark-border p-6">
        <div className="relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 dark:via-white/10 to-transparent skeleton-wave" />
          <div className="h-7 w-1/4 bg-light-hover dark:bg-dark-hover rounded-lg mb-6" />
          <div className="space-y-6">
            {[1, 2].map((i) => (
              <div key={i}>
                <div className="h-5 w-1/4 bg-light-hover dark:bg-dark-hover rounded mb-2" />
                <div className="h-10 bg-light-hover dark:bg-dark-hover rounded-lg" />
              </div>
            ))}
            <div className="h-24 bg-light-hover dark:bg-dark-hover rounded-lg" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsSkeleton;